<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật tài khoản</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="avatar" label="Ảnh đại diện">
              <el-upload
                class="avatar-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.avatar_path" :src="modelData.avatar_path" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh đại diện tải lên có dung lượng tối đa là 2Mb
                </div>
              </el-upload>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Họ và tên" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="sex" label="Giới tính" class="form-item">
                  <el-select v-model="modelData.sex" filterable placeholder="Giới tính" class="input-select">
                    <el-option
                      v-for="item in lists.listSex"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="user_youtube" label="Link video Youtube" class="form-item">
                  <el-input v-model="modelData.user_youtube" :rows="5" type="textarea" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="birthday" label="Ngày sinh" class="form-item input-daterange">
                  <el-date-picker
                    v-model="modelData.birthday"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="Ngày sinh">
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="phone" label="Số điện thoại" class="form-item">
                  <el-input v-model="modelData.phone" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="address" label="Địa chỉ" class="form-item">
                  <el-input v-model="modelData.address" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="user_content" label="Giới thiệu về tài khoản">
              <tinymce
                id="d1"
                v-model="modelData.user_content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'UserUpdate',
  metaInfo () {
    return {
      title: 'Tài khoản | Cập nhật'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        phone: '',
        avatar: '',
        avatar_path: '',
        address: '',
        birthday: '',
        sex: 1,
        user_type: '',
        user_content: '',
        status: true,
        category_user: []
      },
      lists: {
        listUserType: [
          {key: 2, value: 'Giảng viên'},
          {key: 3, value: 'Học viên'}
        ],
        listSex: [
          {key: 1, value: 'Nam'},
          {key: 0, value: 'Nữ'}
        ],
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listDomain: []
      },
      checkAll: false,
      checkedCities: [],
      cities: [], // Danh mục dc học
      isIndeterminate: true,
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'users/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập họ và tên' },
          { min: 2, max: 50, message: 'Họ và tên có chiều dài từ 2 tới 50 kí tự' }
        ],
        user_type: [
          { required: true, message: 'Vui lòng nhập loại tài khoản' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.fetchModel()
    this.configUpload()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'users-for-editor-index', text: 'Tài khoản' },
        { name: 'users-for-editor-create', text: 'Cập nhật' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'users-for-editor-index'})
    },
    // Fetch dữ liệu về lĩnh vực khóa học
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.cities = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch domain
    fetchDomain () {
      let filter = {
        'status': 1,
        'limit': -1
      }
      axios.get('domains', {params: filter}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listDomain = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    handleCheckAllChange (val) {
      this.checkedCities = val ? this.cities : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    checkChecked (city) {
      let index = findIndex(this.checkedCities, function (o) {
        return o.id === city.id
      })
      console.log(index)
      if (index >= 0) {
        return true
      }
      return false
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('users/' + this.$route.params.id, {params: {}}).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            this.checkedCities = response.data.category_user.data
            // console.log(this.checkedCities)
            // this.fetchListCategoryCourse()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      this.modelData.category_user = this.checkedCities

      axios.put('users/' + this.$route.params.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success',
              duration: '1000'
            })
            // this.$router.push({name: 'users-index'})
            // this.$router.push({name: 'users-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh đại diện có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.avatar = response.data.name
        this.modelData.avatar_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>

<style type="text/css">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/users-for-editor/Update.vue